<div class="dhm-wrap">

  @if (loading) {
    <div class="dhm-skeleton">
      <div class="dhm-sk-title"></div>
      <div class="dhm-sk-tags"></div>
      <div class="dhm-sk-canvas"></div>
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="dhm-header">
      <div class="dhm-header__left">
        <span class="dhm-title">Mapa de calor · Posición de objetos</span>
        <span class="dhm-subtitle">Densidad acumulada de bounding boxes ponderada por score</span>
      </div>
      <div class="dhm-stats">
        <div class="dhm-stat">
          <span class="dhm-stat__val" [style.color]="activeTagMeta().color">{{ totalDetections }}</span>
          <span class="dhm-stat__lbl">detecciones</span>
        </div>
        <div class="dhm-stat">
          <span class="dhm-stat__val">{{ avgScore }}%</span>
          <span class="dhm-stat__lbl">score prom.</span>
        </div>
        @if (filteredOut > 0) {
          <div class="dhm-stat dhm-stat--warn">
            <span class="dhm-stat__val dhm-stat__val--sm">{{ filteredOut }}</span>
            <span class="dhm-stat__lbl">filtrados</span>
          </div>
        }
        <div class="dhm-stat dhm-stat--wide">
          <span class="dhm-stat__val dhm-stat__val--sm" [title]="topObject">{{ topObject }}</span>
          <span class="dhm-stat__lbl">objeto top</span>
        </div>
      </div>
    </div>

    <!-- Tag selector -->
    <div class="dhm-tag-bar">
      @for (t of tags; track t.key) {
        <button type="button" class="dhm-tag-btn"
                [class.is-active]="activeTag === t.key"
                [style.--tc]="t.color"
                (click)="setTag(t.key)">
          <span class="dhm-tag-dot" [style.background]="t.color"></span>
          {{ t.label }}
        </button>
      }
    </div>

    <!-- Controles -->
    <div class="dhm-controls">

      <!-- Slider score threshold -->
      <div class="dhm-control-group">
        <label class="dhm-control-label">
          Score mínimo
          <span class="dhm-control-val" [style.color]="activeTagMeta().color">{{ thresholdLabel }}</span>
        </label>
        <div class="dhm-slider-wrap">
          <span class="dhm-slider-min">0%</span>
          <input type="range" class="dhm-slider"
                 [style.--tc]="activeTagMeta().color"
                 min="0" max="99" step="5"
                 [(ngModel)]="scoreThreshold"
                 (ngModelChange)="onThresholdChange()" />
          <span class="dhm-slider-max">99%</span>
        </div>
      </div>

      <!-- Toggle Others -->
      <div class="dhm-control-group">
        <label class="dhm-control-label">Incluir "Others"</label>
        <div class="dhm-others-info">
          <button type="button" class="dhm-toggle"
                  [class.is-on]="includeOthers"
                  [style.--tc]="activeTagMeta().color"
                  (click)="includeOthers = !includeOthers; onOthersToggle()">
            <span class="dhm-toggle__track">
              <span class="dhm-toggle__thumb"></span>
            </span>
            {{ includeOthers ? 'Sí' : 'No' }}
          </button>
          @if (othersCount > 0) {
            <span class="dhm-others-badge">{{ othersCount }} sin clasificar</span>
          }
        </div>
      </div>

    </div>

    <!-- Canvas heatmap -->
    <div class="dhm-canvas-wrap">
      <span class="dhm-axis dhm-axis--x">← Posición horizontal →</span>
      <span class="dhm-axis dhm-axis--y">↕ Vertical</span>
      <canvas #heatCanvas class="dhm-canvas" width="600" height="500"></canvas>
      @if (totalDetections === 0) {
        <div class="dhm-no-data">
          <i class="pi pi-map"></i>
          <span>
            Sin detecciones para
            <strong [style.color]="activeTagMeta().color">{{ activeTagMeta().label }}</strong>
            con score ≥ {{ thresholdLabel }}
          </span>
        </div>
      }
    </div>

    <!-- Leyenda -->
    <div class="dhm-legend-row">
      <div class="dhm-legend-item">
        <span class="dhm-legend-dot" [style.background]="activeTagMeta().color" style="opacity:.2"></span>
        <span>Baja concentración</span>
      </div>
      <div class="dhm-legend-item">
        <span class="dhm-legend-dot" [style.background]="activeTagMeta().color" style="opacity:.6"></span>
        <span>Media</span>
      </div>
      <div class="dhm-legend-item">
        <span class="dhm-legend-dot" [style.background]="activeTagMeta().color"></span>
        <span>Alta concentración</span>
      </div>
      <span class="dhm-legend-note">
        Ponderado por score de confianza · "Others" excluidos por defecto
      </span>
    </div>

  }
</div>
